// BREAKPOINTS
// $xs: 0;
export const XS = 0;

// $sm: 576px;
export const SM = '36rem';

// $md: 768px;
export const MD = '48rem';

// $lg: 992px;
export const LG = '62rem';

// $xl: 1200px;
export const XL = '75rem';

// COLORS
// RED MARVEL
export const marvelRed = '#e62429';
export const marvelRedDarken = '#770d10';
export const marvelGrey = '#202020';

